var map = {
	"./abw.svg": 42850,
	"./afg.svg": 44774,
	"./ago.svg": 35513,
	"./aia.svg": 67677,
	"./ala.svg": 99850,
	"./alb.svg": 25849,
	"./and.svg": 62125,
	"./are.svg": 52896,
	"./arg.svg": 10178,
	"./arm.svg": 60152,
	"./asm.svg": 51367,
	"./ata.svg": 19986,
	"./atf.svg": 53917,
	"./atg.svg": 25372,
	"./aus.svg": 75715,
	"./aut.svg": 77788,
	"./aze.svg": 92744,
	"./bdi.svg": 54641,
	"./bel.svg": 5391,
	"./ben.svg": 31613,
	"./bes.svg": 95096,
	"./bfa.svg": 86135,
	"./bgd.svg": 10381,
	"./bgr.svg": 26339,
	"./bhr.svg": 28998,
	"./bhs.svg": 43383,
	"./bih.svg": 11199,
	"./blm.svg": 86165,
	"./blr.svg": 12674,
	"./blz.svg": 96218,
	"./bmu.svg": 47422,
	"./bol.svg": 29421,
	"./bra.svg": 56811,
	"./brb.svg": 17976,
	"./brn.svg": 41836,
	"./btn.svg": 22942,
	"./bvt.svg": 53466,
	"./bwa.svg": 14576,
	"./caf.svg": 71620,
	"./can.svg": 26124,
	"./cck.svg": 31543,
	"./che.svg": 48928,
	"./chl.svg": 39465,
	"./chn.svg": 43435,
	"./civ.svg": 17580,
	"./cmr.svg": 66908,
	"./cod.svg": 45452,
	"./cog.svg": 799,
	"./cok.svg": 53099,
	"./col.svg": 90948,
	"./com.svg": 45669,
	"./cpv.svg": 51195,
	"./cri.svg": 12294,
	"./cub.svg": 7620,
	"./cuw.svg": 51033,
	"./cxr.svg": 23807,
	"./cym.svg": 10935,
	"./cyp.svg": 68594,
	"./cze.svg": 5050,
	"./deu.svg": 78804,
	"./dji.svg": 61621,
	"./dma.svg": 59136,
	"./dnk.svg": 90835,
	"./dom.svg": 21886,
	"./dza.svg": 18157,
	"./ecu.svg": 90507,
	"./egy.svg": 27587,
	"./eri.svg": 85400,
	"./esh.svg": 5742,
	"./esp.svg": 51318,
	"./est.svg": 16330,
	"./eth.svg": 47319,
	"./fin.svg": 30013,
	"./fji.svg": 51263,
	"./flk.svg": 90119,
	"./fra.svg": 84031,
	"./fro.svg": 85385,
	"./fsm.svg": 10972,
	"./gab.svg": 68268,
	"./gbr.svg": 63249,
	"./geo.svg": 1685,
	"./ggy.svg": 39389,
	"./gha.svg": 72240,
	"./gib.svg": 564,
	"./gin.svg": 91504,
	"./glp.svg": 68197,
	"./gmb.svg": 23384,
	"./gnb.svg": 58045,
	"./gnq.svg": 17102,
	"./grc.svg": 80288,
	"./grd.svg": 22495,
	"./grl.svg": 39415,
	"./gtm.svg": 67560,
	"./guf.svg": 91692,
	"./gum.svg": 62903,
	"./guy.svg": 1339,
	"./hkg.svg": 16012,
	"./hmd.svg": 59297,
	"./hnd.svg": 50344,
	"./hrv.svg": 1798,
	"./hti.svg": 42355,
	"./hun.svg": 42083,
	"./idn.svg": 86637,
	"./imn.svg": 93734,
	"./ind.svg": 31381,
	"./iot.svg": 62866,
	"./irl.svg": 99985,
	"./irn.svg": 8083,
	"./irq.svg": 76948,
	"./isl.svg": 29694,
	"./isr.svg": 81976,
	"./ita.svg": 49418,
	"./jam.svg": 59618,
	"./jey.svg": 48266,
	"./jor.svg": 6659,
	"./jpn.svg": 82722,
	"./kaz.svg": 51864,
	"./ken.svg": 8056,
	"./kgz.svg": 10,
	"./khm.svg": 87024,
	"./kir.svg": 17608,
	"./kna.svg": 18170,
	"./kor.svg": 60730,
	"./kwt.svg": 12588,
	"./lao.svg": 63890,
	"./lbn.svg": 24858,
	"./lbr.svg": 6270,
	"./lby.svg": 80629,
	"./lca.svg": 53854,
	"./lie.svg": 89952,
	"./lka.svg": 77974,
	"./lso.svg": 65624,
	"./ltu.svg": 14811,
	"./lux.svg": 57401,
	"./lva.svg": 45321,
	"./mac.svg": 1939,
	"./maf.svg": 68494,
	"./mar.svg": 89298,
	"./mco.svg": 40393,
	"./mda.svg": 32086,
	"./mdg.svg": 23080,
	"./mdv.svg": 16297,
	"./mex.svg": 63068,
	"./mhl.svg": 15583,
	"./mkd.svg": 10698,
	"./mli.svg": 6710,
	"./mlt.svg": 37107,
	"./mmr.svg": 72990,
	"./mne.svg": 67112,
	"./mng.svg": 30634,
	"./mnp.svg": 46373,
	"./moz.svg": 62768,
	"./mrt.svg": 78773,
	"./msr.svg": 85356,
	"./mtq.svg": 42550,
	"./mus.svg": 41911,
	"./mwi.svg": 96523,
	"./mys.svg": 33307,
	"./myt.svg": 23540,
	"./nam.svg": 37806,
	"./ncl.svg": 57397,
	"./ner.svg": 38189,
	"./nfk.svg": 34449,
	"./nga.svg": 28372,
	"./nic.svg": 23792,
	"./niu.svg": 2862,
	"./nld.svg": 24632,
	"./nor.svg": 32431,
	"./npl.svg": 95596,
	"./nru.svg": 2939,
	"./nzl.svg": 20970,
	"./omn.svg": 62084,
	"./pak.svg": 82978,
	"./pan.svg": 33279,
	"./pcn.svg": 52325,
	"./per.svg": 77087,
	"./phl.svg": 73314,
	"./plw.svg": 95941,
	"./png.svg": 97699,
	"./pol.svg": 55787,
	"./pri.svg": 36585,
	"./prk.svg": 99915,
	"./prt.svg": 92348,
	"./pry.svg": 78617,
	"./pse.svg": 56382,
	"./pyf.svg": 48495,
	"./qat.svg": 10472,
	"./reu.svg": 74390,
	"./rou.svg": 71908,
	"./rus.svg": 46968,
	"./rwa.svg": 82912,
	"./sau.svg": 55927,
	"./sdn.svg": 23140,
	"./sen.svg": 2464,
	"./sgp.svg": 17192,
	"./sgs.svg": 98555,
	"./shn.svg": 4027,
	"./sjm.svg": 21410,
	"./slb.svg": 77451,
	"./sle.svg": 9860,
	"./slv.svg": 16455,
	"./smr.svg": 53484,
	"./som.svg": 43349,
	"./spm.svg": 21456,
	"./srb.svg": 13149,
	"./ssd.svg": 21792,
	"./stp.svg": 39089,
	"./sur.svg": 27908,
	"./svk.svg": 79712,
	"./svn.svg": 49165,
	"./swe.svg": 27637,
	"./swz.svg": 88322,
	"./sxm.svg": 88152,
	"./syc.svg": 93921,
	"./syr.svg": 79040,
	"./tca.svg": 4406,
	"./tcd.svg": 87707,
	"./tgo.svg": 51924,
	"./tha.svg": 94219,
	"./tjk.svg": 11287,
	"./tkl.svg": 72571,
	"./tkm.svg": 54730,
	"./tls.svg": 40069,
	"./ton.svg": 18061,
	"./tto.svg": 21177,
	"./tun.svg": 84703,
	"./tur.svg": 31675,
	"./tuv.svg": 53767,
	"./twn.svg": 8197,
	"./tza.svg": 53341,
	"./uga.svg": 77339,
	"./ukr.svg": 76812,
	"./umi.svg": 47933,
	"./undefined.svg": 55598,
	"./unk.svg": 61622,
	"./ury.svg": 62616,
	"./usa.svg": 92359,
	"./uzb.svg": 63579,
	"./vat.svg": 34047,
	"./vct.svg": 63557,
	"./ven.svg": 56193,
	"./vgb.svg": 76799,
	"./vir.svg": 25625,
	"./vnm.svg": 67135,
	"./vut.svg": 4443,
	"./wlf.svg": 7851,
	"./wsm.svg": 96997,
	"./yem.svg": 65805,
	"./zaf.svg": 58585,
	"./zmb.svg": 841,
	"./zwe.svg": 48900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22256;